<template>
  <div>
    <!-- <div class="adabundle-subheader"><h4>Accessibility modes</h4></div> -->

    <div id="adabundle-accessibility-profiles-box">


        <div v-for="profile in accessibility_profiles" v-show="profile.status == 1" :id="profile.id" class="adabundle-accessibility-profile-item" tabindex="0">
            <div class="adabundle-row">

                <AccessibilitySwitch :id="profile.id" :t="t" />

                <div class="adabundle-title-box">
                    <div class="adabundle-profile-title">{{profile.title}}</div>
                    <div class="adabundle-profile-short">{{profile.short}}</div>
                </div>



            </div>
            <div class="adabundle-profile-description">
                {{profile.description}}
            </div>
        </div>

    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import AccessibilitySwitch from "./AccessibilitySwitch.vue";
import Utility from '../common/Utility';
import  HTTP from "../common/Http";

export default {
  name: "AccessibilityModes",

  created () {
    this.init()
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setWidgetOptions') {
        this.widgetOptions = state.widgetOptions;
      }

      if (mutation.type === 'setWidgetLanguage') {
        this.init();
      }
    });
  },
  mounted(){
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  data () {
    return {
      isLoading: false,
      accessibility_profiles: [] 
    }
  },
  computed: {
    ...mapState([
      "timeStamp",
      "wid",
      "widgetOptions",
      "debug",
      "t"
    ])
  },
  methods: {
    init(){
        // this.accessibility_profiles = [
        //   {
        //     id : 'adabundle-accessibility-profile-epilepsy',
        //     title: 'Epilepsy Safe Mode',
        //     short: 'Dampens color and removes blinks',
        //     description: 'This mode enables people with epilepsy to use the website safely by eliminating the risk of seizures that result from flashing or blinking animations and risky color combinations.',
        //     status: this.widgetOptions.profileEpilepsy
        //   },
        //   {
        //     id : 'adabundle-accessibility-profile-visually-impaired',
        //     title: 'Visually Impaired Mode',
        //     short: "Improves website's visuals",
        //     description: 'This mode adjusts the website for the convenience of users with visual impairments such as Degrading Eyesight, Tunnel Vision, Cataract, Glaucoma, and others.',
        //     status: this.widgetOptions.profileVisuallyImpaired
        //   },
        //   {
        //     id : 'adabundle-accessibility-profile-cognitive-disability',
        //     title: 'Cognitive Disability Mode',
        //     short: 'Helps to focus on specific content',
        //     description: 'This mode provides different assistive options to help users with cognitive impairments such as Dyslexia, Autism, CVA, and others, to focus on the essential elements of the website more easily.',
        //     status: this.widgetOptions.profileCognitiveDisability
        //   },
        //   {
        //     id : 'adabundle-accessibility-profile-adhd-friendly',
        //     title: 'ADHD Friendly Mode',
        //     short: 'Reduces distractions and improve focus',
        //     description: 'This mode helps users with ADHD and Neurodevelopmental disorders to read, browse, and focus on the main website elements more easily while significantly reducing distractions.',
        //     status: this.widgetOptions.profileAdhdFriendly
        //   },
        //   {
        //     id : 'adabundle-accessibility-profile-blind-users',
        //     title: 'Blindness Mode',
        //     short: 'Allows using the site with your screen-reader',
        //     description: 'This mode configures the website to be compatible with screen-readers such as JAWS, NVDA, VoiceOver, and TalkBack. A screen-reader is software for blind users that is installed on a computer and smartphone, and websites must be compatible with it.',
        //     status: this.widgetOptions.profileBlindUsers
        //   }
        // ];

        const t = this.t;

        this.accessibility_profiles = [
          {
            id : 'adabundle-accessibility-profile-epilepsy',
            title: t.epilepsy.title,
            short: t.epilepsy.subtitle,
            description: t.epilepsy.description,
            status: this.widgetOptions.profileEpilepsy
          },
          {
            id : 'adabundle-accessibility-profile-visually-impaired',
            title: t.visually_impaired.title,
            short: t.visually_impaired.subtitle,
            description: t.visually_impaired.description,
            status: this.widgetOptions.profileVisuallyImpaired
          },
          {
            id : 'adabundle-accessibility-profile-cognitive-disability',
            title: t.cognitive_disability.title,
            short: t.cognitive_disability.subtitle,
            description: t.cognitive_disability.description,
            status: this.widgetOptions.profileCognitiveDisability
          },
          {
            id : 'adabundle-accessibility-profile-adhd-friendly',
            title: t.adhd_friendly.title,
            short: t.adhd_friendly.subtitle,
            description: t.adhd_friendly.description,
            status: this.widgetOptions.profileAdhdFriendly
          },
          {
            id : 'adabundle-accessibility-profile-blind-users',
            title: t.blindness.title,
            short: t.blindness.subtitle,
            description: t.blindness.description,
            status: this.widgetOptions.profileBlindUsers
          }
        ]
     }
  },
  components: {
    AccessibilitySwitch
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
